import { LOANS_FETCHED } from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case LOANS_FETCHED:
      return { ...state, list: action.data.loans || [] };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/loans.js